import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const sliderStyle = (contactIntervals, step) => {
    const offset = 20 - 40 * step / (contactIntervals.length - 1);
    var num = step / (contactIntervals.length - 1) * 100;
    const style = { background: 'linear-gradient(to right, #0A2463 ' + num.toString() + '%, #C6C6C9 ' + num.toString() + '% 100%)', '--offset-thumb': `${offset * -1}px` };
    return style;
};

const tooltipLabelStyle = (contactIntervals, step) => {
    const pct = (step / (contactIntervals.length - 1 || 0));
    const left = pct * 100;
    const style = { left: `calc(${left}%)` };
    return style;
};

function ContactSlider({
    contactIntervals = [],
    pricePerContact = [],
    currentStep = 0,
    selectContactAmount = () => {},
}) {
    const [step, setStep] = useState(currentStep);

    const stepChange = (e) => {
        if (typeof e === 'object') {
            setStep(Number(e?.target?.value) ?? step);
        } else {
            setStep(Number(e) ?? step);
        }
    };

    const increaseValue = () => {
        if (step < contactIntervals.length - 1) {
            stepChange(step + 1);
        }
    };

    const decreaseValue = () => {
        if (step > 0) {
            stepChange(step - 1);
        }
    };

    useEffect(() => {
        selectContactAmount(step);
    }, [step]);

    return (
        <div className="margin-t-24px margin-b-24px margin-l-24px margin-r-24px">
            <div className="flex width-100">
                <i aria-label="decrease" className={'fas fa-chevron-left margin-r-24px cursor-pointer arrow-button' + (step <= 0 ? ' vis-hidden' : '')} onClick={() => decreaseValue()}></i>
                <div className="relative flex-100">
                    <datalist role="label" id="track-spaces" className="track-spaces">
                        { contactIntervals.map((item, indexSpace) => <option key={indexSpace} value={contactIntervals[indexSpace]} className="cursor-pointer"/>)}
                    </datalist>
                    <input role="slider" id="slider" value={step} onChange={stepChange} type="range" min="0" max={contactIntervals.length - 1} step="1" list="tickmarks" style={sliderStyle(contactIntervals, step)}/>
                    <output htmlFor="slider" className="flex align-items-center bg-white" style={tooltipLabelStyle(contactIntervals, step)}>
                        <div aria-label="contacts" className="flex-100 flex flex-dir-col"><span className="font-serif">{contactIntervals[step]}</span><span className="font-gray-16 font-size-14px">contacts</span></div>
                        <div aria-label="divider" className={'vl' + (step === 0 ? ' none' : '')}></div>
                        <div aria-label="price" className={'flex-100 flex flex-dir-col' + (step === 0 ? ' none' : '')}><span className="font-serif">{pricePerContact[step]}</span><span className="font-gray-16 font-size-14px">per contact</span></div>
                    </output>
                    <datalist role="label" id="tickmarks">
                        { contactIntervals.map((item, indexTick) => <div key={indexTick} className="tick-container">
                            <div className="tick-parent">
                                <option value={contactIntervals[indexTick]} label={contactIntervals[indexTick]} className="cursor-pointer" onClick={() => setStep(indexTick)}/>
                            </div>
                        </div>)}
                    </datalist>
                </div>
                <i aria-label="increase" className={'arrow fas fa-chevron-right margin-l-24px cursor-pointer arrow-button' + (step >= contactIntervals.length - 1 ? ' vis-hidden' : '')} onClick={() => increaseValue()}></i>
            </div>
        </div>
    );
}

ContactSlider.propTypes = {
    contactIntervals: PropTypes.array.isRequired,
    pricePerContact: PropTypes.array.isRequired,
    currentStep: PropTypes.number,
    selectContactAmount: PropTypes.func.isRequired,
};

export default ContactSlider;
